module.exports = __webpack_public_path__ + "img/illustration-090323-raw.647efe42.jpeg";